import React from 'react';
import { Box, Typography, Link } from '@mui/material';

const CookiePolicy: React.FC = () => (
  <Box sx={{ p: 3, maxWidth: 800, mx: 'auto', mt: 10 }}>
    <Typography variant="h3" gutterBottom>Cookie Policy</Typography>
    <Typography variant="body2" gutterBottom>Last updated: 1 January 2025</Typography>

    <Typography paragraph>Cookies are small text files stored on your device. We use them to operate and measure the service.</Typography>

    <Typography variant="h5" gutterBottom>Essential Cookies</Typography>
    <Typography paragraph>Required for features like authentication and security. You cannot opt out of these.</Typography>

    <Typography variant="h5" gutterBottom>Analytics Cookies</Typography>
    <Typography paragraph>Help us understand how Enantio is used. These cookies are optional and will only run if you consent via the cookie banner.</Typography>

    <Typography variant="h5" gutterBottom>Managing Cookies</Typography>
    <Typography paragraph>You can change your cookie preferences at any time through the banner or by clearing cookies in your browser. Declining cookies may impact some features.</Typography>

    <Typography variant="h5" gutterBottom>Contact</Typography>
    <Typography paragraph>Questions? Email us at <Link href="mailto:privacy@traitindicator.com">privacy@traitindicator.com</Link>.</Typography>
  </Box>
);

export default CookiePolicy;
